export const pickRandomIndex = (
  count: number,
  random: () => number,
): number => Math.floor(random() * count);
